export default __webpack_public_path__ + "static/media/sparks-3.4e5a9f23.png";